import type { ImageObject } from '@/modules/annotator/types';

import type { LatestImage } from '../../@types/latestImages';
import { VIDEA_DENTAL_ASSIST_CARIES } from '../../constants';
import { PracticeFeatureFlagKey, useFeatureFlag } from '../user';

export const useIsVDAPracticeWithNonVDAAnalysis = (
  images: LatestImage[] | ImageObject[] | undefined,
) => {
  const isVdaEnabled = !!useFeatureFlag(
    PracticeFeatureFlagKey.VIDEA_DENTAL_ASSIST_ENABLED,
  )?.value;
  const isVdaPracticeWithNonVdaAnalysis = () => {
    return (
      !!images &&
      isVdaEnabled &&
      images.some(
        (image) =>
          image.models?.caries?.type &&
          image.models.caries.type !== VIDEA_DENTAL_ASSIST_CARIES,
      )
    );
  };
  return isVdaPracticeWithNonVdaAnalysis();
};
